/** @format */

// To share the state between components write thw following three lines
// Otherwise each component creates a new instance of the reactive state object that can not sher the state
import Vue from 'vue'
import VueCompositionApi, { reactive, toRefs } from '@vue/composition-api'
// import dateformat from 'dateformat'

Vue.use(VueCompositionApi)
import Store from '@/store'
import useExchangeRate from '@/_srcv2/components/_shared/exchange-api/useExchangeRates.js'
// Cleave
// eslint-disable-next-line no-unused-vars
import cleave from 'cleave.js'
console.log('===>>>> useOrderHeadersModelSchemaOptions.js is initialized')

const { getExchangeRates } = useExchangeRate()

const modelOrder = reactive({
	selectedDate: '',
	isDatePickerDisabled: '',
	showExchangeFieldsOnForm: '',
	orderType: '',
	orderLanguage: '',
	orderExchangeUnit: '',
	orderExchangeRate: '',
	dispatchAddressId: '',
	invoiceAddressId: '',
})
const schemaOrder = reactive({
	groups: [
		{
			fields: [
				{
					type: 'select',
					label: 'Order Type',
					model: 'orderType',
					id: 'order-type',
					hint: 'Please select order type',
					values: ['Inland', 'Inside EU', 'Outside EU'],
					default: 'Inland',
					featured: false,
					required: false,
					readonly: false,
					disabled: true,
					validator: ['string'],
					onValidated: function (model, errors) {
						if (errors.length > 0) {
							console.log(
								'Validation error in Order type field! Errors:',
								errors,
							)
						} else {
							if (
								model.orderType === 'Inside EU' ||
								model.orderType === 'Outside EU'
							) {
								model.showExchangeFieldsOnForm = true
							} else {
								model.showExchangeFieldsOnForm = false
								model.orderLanguage = 'se'
								model.orderExchangeUnit = 'kr.'
								model.orderExchangeRate = 1.0
							}
						}
					},
				},
				{
					// ? Only appear if packet value is true
					visible(model) {
						return model && model.showExchangeFieldsOnForm === true
					},
					type: 'select',
					label: 'Order Language',
					model: 'orderLanguage',
					hint: 'Please select order language',
					values: ['en', 'se'],
					featured: true,
					required: true,
					readonly: false,
					disabled: false,
					validator: ['string'],
					onValidated: function (model, errors) {
						if (errors.length > 0) {
							Store.dispatch('setDisableSaveOrderHeaders', true)
							console.log(
								'Validation error in Order Language field! Errors:',
								errors,
							)
						}
					},
				},
				{
					// ? Only appear if packet value is true
					visible(model) {
						return model && model.showExchangeFieldsOnForm === true
					},
					type: 'select',
					label: 'Order Exchange Unit',
					model: 'orderExchangeUnit',
					hint: 'Please select order exchange unit',
					values: ['kr.', '€', '$', 'NOK', 'DKK', 'TRY', 'PLN'],
					featured: true,
					required: true,
					readonly: false,
					disabled: false,
					validator: ['string'],
					onValidated: function (model, errors) {
						if (errors.length > 0) {
							Store.dispatch('setDisableSaveOrderHeaders', true)
							console.log(
								'Validation error in Order Exchange Unit field! Errors:',
								errors,
							)
						} else if (model.orderExchangeUnit === 'kr.') {
							console.log('kr. is selected')
							model.orderExchangeRate = 1.0
							model.isDatePickerDisabled = true
						} else {
							console.log(`${model.orderExchangeUnit} is selected`)
							const getExcUnit = (unit) => {
								switch (unit) {
									case '$':
										return 'USD'
									case '€':
										return 'EUR'
									case 'TRY':
										return 'TRY'
									case 'NOK':
										return 'NOK'
									case 'DKK':
										return 'DKK'
									case 'PLN':
										return 'PLN'
									default:
										return 'kr.'
								}
							}
							getExchangeRates(getExcUnit(model.orderExchangeUnit)).then(
								(excRate) => {
									console.log('From schema excRate', excRate)
									model.orderExchangeRate = excRate
									model.isDatePickerDisabled = true
								},
							)
						}
					},
				},
				{
					// Only appear if packet value is true
					visible(model) {
						return model && model.showExchangeFieldsOnForm === true
					},
					type: 'cleave',
					label: 'Order Exchange Rate',
					model: 'orderExchangeRate',
					placeholder: 'Please enter order exchange rate',
					featured: true,
					required: true,
					readonly: false,
					disabled: false,
					validator: ['positivenumber', 'required'],
					cleaveOptions: {
						numeral: true,
						numeralThousandsGroupStyle: 'thousand',
						numeralDecimalScale: 6,
						numeralDecimalMark: '.',
					},
					onValidated: function (model, errors) {
						if (errors.length > 0) {
							console.log('ERROR!!!')
							console.log(
								'Validation error in Order Exchange Rate field! Errors:',
								errors,
							)
						} else {
							console.log('NO ERROR!!!')
						}
					},
				},
				{
					type: 'select',
					label: 'Dispatch Address',
					model: 'dispatchAddressId',
					placeholder: 'Please select dispatch address',
					required: true,
					featured: true,
					readonly: false,
					disabled: false,
					values: [],
				},
				{
					type: 'select',
					label: 'Invoice Address',
					model: 'invoiceAddressId',
					placeholder: 'Please select sale-invoice address',
					required: true,
					featured: true,
					readonly: false,
					disabled: false,
					values: [],
				},
			],
		},
	],
})
const formOptionsOrder = reactive({
	validateAfterLoad: true,
	validateAfterChanged: true,
	validateAsync: true,
	fieldIdPrefix: 'orderForm',
})

export default function useOrderHeadersModelSchemaOptions() {
	return {
		modelOrder,
		schemaOrder,
		formOptionsOrder,
		...toRefs(modelOrder),
	}
}
